import React, { useEffect } from 'react';
import { useLenis } from '@studio-freight/react-lenis';
import { useLocation } from '@reach/router';

export const ScrollToHash = () => {
	const lenis = useLenis();
	const location = useLocation();

	useEffect(() => {
		if (!lenis) return;

		// Wait until DOM is ready (Gatsby can SSR)
		const handleHash = () => {
			if (!location.hash) return;

			const id = location.hash.replace('#', '');
			const target = document.getElementById(id);

			if (target) {
				// Use a small timeout to allow layout/images to settle
				setTimeout(() => {
					lenis.scrollTo(target, { offset: -80, duration: 1.2 });
				}, 200);
			}
		};

		handleHash();
	}, [lenis, location]);

	return null;
};
